import { render, staticRenderFns } from "./ExercisesIntroduceAdvise.vue?vue&type=template&id=964e8cde"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./ExercisesIntroduceAdvise.vue?vue&type=style&index=0&id=964e8cde&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports